export default __webpack_public_path__ + "static/media/arrow_down.80b417d7.svg";